import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "../../components/navbar";
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer/Footer";
import routes from "../../routes";
import { usePermissions } from "../../auth/PermissionProvider";
import { podeAcessarRota } from "../../auth/routePermission";
import { homeRouteFor } from "../../utils/homeRoute";
import api from "../../services/axios";
import CopilotWidget from "../../components/copilot/CopilotWidget";
import { TemaProvider } from "../../theme/TemaProvider";

// O provider fica por fora para o tema da organização valer em toda a área logada.
export default function Admin(props: { [x: string]: any }) {
  return (
    <TemaProvider>
      <AdminConteudo {...props} />
    </TemaProvider>
  );
}

function AdminConteudo(props: { [x: string]: any }) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(
    () => typeof window !== "undefined" && window.innerWidth >= 1200
  );
  const [currentRoute, setCurrentRoute] = React.useState("Início");
  const [profileName, setProfileName] = React.useState<string>("");
  const { can, permissions } = usePermissions();

  // Mesma regra do SignIn — uma fonte só (ver utils/homeRoute.ts).
  const homeRoute = homeRouteFor(permissions);

  React.useEffect(() => {
    const handleResize = () => setOpen(window.innerWidth >= 1200);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fecha o drawer ao navegar em telas pequenas
  React.useEffect(() => {
    if (window.innerWidth < 1200) setOpen(false);
  }, [location.pathname]);

  React.useEffect(() => {
    getActiveRoute(routes);
  }, [location.pathname]);

  React.useEffect(() => {
    // Employee Data
    const emailLoSto = localStorage.getItem("userEmail");
    api
      .get(`/Employee/${emailLoSto}`)
      .then((response) => {
        localStorage.setItem("userName", response.data.nmEmployee);
        setProfileName(response.data.nmEmployee);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }, [profileName]);

  const getActiveRoute = (routes: RoutesType[]): string | boolean => {
    let activeRoute = "Profile";
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(
          routes[i].layout + "/" + routes[i].path
        ) !== -1
      ) {
        setCurrentRoute(routes[i].name);
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes: RoutesType[]): string | boolean => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].secondary;
      }
    }
    return activeNavbar;
  };
  /**
   * Só registra as rotas cuja permissão o usuário tem. Rota sem `permission` declarada NÃO é
   * registrada: se alguém esquecer de declarar, o item some — falha fechada, e visível na hora.
   */
  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin" && prop.permission && podeAcessarRota(can, prop.permission)) {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <div className="flex h-[100dvh] w-full overflow-hidden">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      {/* Backdrop do drawer em telas menores */}
      {open && (
        <div
          className="fixed inset-0 z-40 bg-navy-900/40 backdrop-blur-sm xl:hidden"
          onClick={() => setOpen(false)}
          aria-hidden="true"
        />
      )}
      {/* Navbar fixa + região de conteúdo rolável (só ela rola) */}
      <div className="nina-app-bg flex h-full w-full flex-col overflow-hidden xl:pl-[300px]">
        <div className="shrink-0 px-3 pt-3 md:pr-3">
          <Navbar
            onOpenSidenav={() => setOpen(true)}
            brandText={currentRoute}
            secondary={getActiveNavbar(routes)}
            profileUserName={profileName}
            {...rest}
          />
        </div>
        <main className="flex-1 overflow-y-auto overflow-x-hidden px-3 pb-3 md:pr-3">
          <Routes>
            {getRoutes(routes)}

            <Route path="/" element={<Navigate to={homeRoute} replace />} />

            {/*
              Fallback obrigatório: getRoutes só registra as rotas do papel do usuário, então uma
              URL sem permissão (ou inexistente) não casava com nada e a tela ficava EM BRANCO —
              sem erro e sem redirect. Uma linha fecha a classe inteira de bug.
            */}
            <Route path="*" element={<Navigate to={homeRoute} replace />} />
          </Routes>
          <Footer />
        </main>
      </div>
      <CopilotWidget />
    </div>
  );
}
